/**
 * Finds the highest latitude value from a polyline array
 * @param polyline - Array of coordinate pairs [longitude, latitude]
 * @returns The highest latitude value, or null if the array is empty
 */

import { LatLngExpression } from "leaflet";


interface GpxPoint {
  lat: number;
  lon: number;
}

function convertToGpxPoints(polyline: Array<LatLngExpression>): Array<GpxPoint> {
  return polyline.map((p: any) => ({ lat: p.lat, lon: p.lng }));
}

export const avgRouteCoords = (ismobile: boolean, polyline: Array<LatLngExpression>): GpxPoint=> {

    const poly = convertToGpxPoints(polyline);

  const latitudes = poly.map(p=>p.lat);
  const longitudes = poly.map(p=>p.lon);

  const avgLat = (Math.max(...latitudes) + Math.min(...latitudes)) / 2;
  const avgLon = (Math.max(...longitudes) + Math.min(...longitudes)) / 2;

  if (ismobile) { 
   const  avgLonReduced = avgLon 
   const  avgLatReduced = avgLat -0.08 
    return {lon: avgLonReduced, lat: avgLatReduced};

  }

  return {lon : avgLon,lat:  avgLat}
};

